// import { $req } from "../utils";
import request from '../utils/request'
export default {
	/*-------------------------------------------------------------设备start-----------------------------------------------------------  */

	//工程-厂区列表 - 李旭
	factoryList({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/project/factory/list`,
			data: params
		})
	},
	//工程-功能区列表 - 李旭
	functionalAreaList({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/project/functionalArea/list`,
			data: params
		})
	},
	//工程-工程阶段列表 - 李旭
	stageList({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/project/stage/list`,
			data: params
		})
	},
	//工程-项目预算暂存 - 李旭
	projectSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/project/save`,
			data: params
		})
	},
	//工程-项目预算详情 - 李旭
	projectDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/project/detail`,
			data: params
		})
	},
	//工程-项目预算删除 - 李旭
	projectDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/project/delete`,
			data: params
		})
	},
	//工程-项目预算列表查看 - 李旭
	projectQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/project/query`,
			data: params
		})
	},
	//工程-项目预算列表查看 - 李旭
	publish({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/project/publish`,
			data: params
		})
	},
	//工程-项目预算列表查看 - 李旭
	projectList({ ...params }) {		
		return request({
			method: 'POST',
			url: `/bpc/project/project/list`,
			data: params
		})
	}
	,
	//查询项目列表（完成） - 李旭 老接口：pmp/project/getList，新接口：pmp/project/forbpc/getList
	projectListNew({ ...params }) {
		return request({
			method: 'POST',
			url: `/pmp/project/forbpc/getList`,
			data: params
		})
	}

}
